/**
 * GLOBAL-FILTER-ENGINE-000001 — deep link helpers.
 * Preserve full global context when navigating across modules.
 */
import { applyContextToSearchParams } from './urlCodec';
import type { UniversalBusinessContext } from './types';
import { patchContext } from './urlCodec';

/** Build absolute in-app path + query with current context (optional patch applied first). */
export function buildDeepLink(
  path: string,
  ctx: UniversalBusinessContext,
  patch?: Partial<UniversalBusinessContext>,
  extraParams?: Record<string, string | undefined>,
): string {
  const next = patch ? patchContext(ctx, patch) : ctx;
  const [pathname, existingQs] = path.split('?');
  const sp = applyContextToSearchParams(next, existingQs ?? '');
  if (extraParams) {
    for (const [k, v] of Object.entries(extraParams)) {
      if (v != null && v !== '') sp.set(k, v);
      else sp.delete(k);
    }
  }
  const qs = sp.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

/** Example flow: Dashboard → Maharashtra → Orders (same seller/mp/dates/state/compare). */
export function deepLinkToOrdersWithState(ctx: UniversalBusinessContext, stateName: string): string {
  return buildDeepLink('/amazon/orders', ctx, { state: stateName });
}
